import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

// Votre configuration Firebase
const firebaseConfig = {
  apiKey: "AIzaSyBPBXgiH6C4mHaZOWjwPlj_1i0dEmksgks",
  authDomain: "firestorecrud-10fbd.firebaseapp.com",
  databaseURL: "https://firestorecrud-10fbd.firebaseio.com",
  projectId: "firestorecrud-10fbd",
  storageBucket: "firestorecrud-10fbd.firebasestorage.app",
  messagingSenderId: "1096407544470",
  appId: "1:1096407544470:web:7897ec3c6f3f02d65048b7",
  measurementId: "G-9G21G274XK"
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);